<template>
  <main>
  <nav class="nav">
    <div class="router-links-container">
      <router-link to="/" class="nav-link">HOME</router-link>
      <router-link to="/trailer" class="nav-link">TRAILER</router-link>
      <!-- <router-link to="/press" class="nav-link">PRESS</router-link> -->
      <router-link to="/screenings" class="nav-link">SCREENINGS</router-link>
      <router-link to="/podcast" class="nav-link">PODCAST</router-link>
      <router-link to="/contact" class="nav-link">CONTACT</router-link>
      <div class="social-media-links-container">
        <a href="https://www.facebook.com/people/Creature-Fear-Film/61555271544540/" target="_blank" class="social-media-link"><img class="fb-logo" src="./assets/facebook.png" alt="Facebook"></a>
        <a href="https://www.instagram.com/creaturefearfilm/" target="_blank" class="social-media-link"><img class="fb-logo" src="./assets/instagram.png" alt="Instagram"></a>
        <a href="https://www.imdb.com/title/tt32131697/" target="_blank" class="social-media-link"><img class="fb-logo social-icon-lg" src="./assets/imdb-white.png" alt="IMDb"></a>
        <a href="https://letterboxd.com/film/creature-fear/" target="_blank" class="social-media-link"><img class="fb-logo social-icon-lg" src="./assets/letterboxd-icon.svg" alt="Letterboxd"></a>
        <!-- <a href="https://fundraising.fracturedatlas.org/creature-fear" target="_blank"><img class="donate-img" alt="Donate now at Fractured Atlas!" src="https://fundraising.fracturedatlas.org/images/fundraiser-share-buttons/share-button--dark--alpha.png" /></a> -->
      </div>
    </div>
  </nav>
  <div class="hamburger-container">
    <div class="hamburger" id="hamburger" @click="toggleHamburger">
      <span class="bar" v-bind:class="{ turned: hamburgerToggled }"></span>
      <span class="bar" v-bind:class="{ turned: hamburgerToggled }"></span>
      <span class="bar" v-bind:class="{ turned: hamburgerToggled }"></span>
    </div>
  </div>
  <nav class="mobile-nav">
    <div class="mobile-nav-links" v-bind:class="{ visible: hamburgerToggled }">
      <div class="mobile-nav-link-container">
        <router-link to="/" class="nav-link mobile" @click="toggleHamburger">home</router-link>
      </div>
      <div class="mobile-nav-link-container">
        <router-link to="/trailer" class="nav-link mobile" @click="toggleHamburger">trailer</router-link>
      </div>
      <!-- <div class="mobile-nav-link-container">
        <router-link to="/press" class="nav-link mobile" @click="toggleHamburger">press</router-link>
      </div> -->
      <div class="mobile-nav-link-container">
        <router-link to="/screenings" class="nav-link mobile" @click="toggleHamburger">screenings</router-link>
      </div>
      <div class="mobile-nav-link-container">
        <router-link to="/podcast" class="nav-link mobile" @click="toggleHamburger">podcast</router-link>
      </div>
      <div class="mobile-nav-link-container">
        <router-link to="/contact" class="nav-link mobile" @click="toggleHamburger">contact</router-link>
      </div>
      <div class="social-media-links-container mobile">
        <a href="https://www.facebook.com/people/Creature-Fear-Film/61555271544540/" target="_blank" class="social-media-link"><img class="fb-logo" src="./assets/facebook.png" alt="Facebook"></a>
        <a href="https://www.instagram.com/creaturefearfilm/" target="_blank" class="social-media-link"><img class="fb-logo" src="./assets/instagram.png" alt="Instagram"></a>
        <a href="https://www.imdb.com/title/tt32131697/" target="_blank" class="social-media-link"><img class="fb-logo social-icon-lg" src="./assets/imdb-white.png" alt="IMDb"></a>
        <a href="https://letterboxd.com/film/creature-fear/" target="_blank" class="social-media-link"><img class="fb-logo social-icon-lg" src="./assets/letterboxd-icon.svg" alt="Letterboxd"></a>
        <div class="donate-link-mobile-container">
          <!-- <a class="donate-link-mobile" href="https://fundraising.fracturedatlas.org/creature-fear" target="_blank"><img class="donate-img mobile-dontate-img" alt="Donate now at Fractured Atlas!" src="https://fundraising.fracturedatlas.org/images/fundraiser-share-buttons/share-button--dark--alpha.png" /></a> -->
        </div>
      </div>
    </div>
  </nav>
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <div>
          <component :is="Component">
          </component>
        </div>
      </transition>
    </router-view>
  </main>

  <FooterComponent />
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import FooterComponent from './views/FooterView.vue'; // Adjust path as necessary

  const isNavFixed = ref(false);

  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
  });

  const handleScroll = () => {
    isNavFixed.value = window.pageYOffset > 0;
  };

  let hamburgerToggled = ref(false);

  let toggleHamburger = () => {
    hamburgerToggled.value = !hamburgerToggled.value
  }
</script>

<style lang="scss">
@import './assets/styles/styles.scss';
#app {
  font-family: IM Fell English SC, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// Sized up relative to the existing fb-logo icons — adjust the multiplier
// below if IMDb/Letterboxd still look small or large next to FB/IG.
.social-icon-lg {
  transform: scale(1.6);
  margin: 0 6px;
}

.fade-enter-from {
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.15s ease-out;
}

.fade-leave-to {
  opacity: 0;
}

.fade-leave-active {
  transition: all 0.15s ease-in;
}
</style>
